// ======================================================================
// File: useRFQList.js
// Module: PPE → Procurement → RFQ
//
// Purpose:
// - Fetch RFQ list
// - Handle pagination
// - Provide summary stats
// - Mirror usePurchaseRequestList.js pattern
// ======================================================================

import { useEffect, useState } from "react";
import rfqService from "../services/rfqService";

export default function useRFQList(filters = {}) {

  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [summary, setSummary] = useState({});
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
    total: 0,
  });

  const loadData = async (params = {}) => {
    setLoading(true);

    try {
      const response = await rfqService.getRFQs({
        page: pagination.page,
        page_size: pagination.pageSize,
        ...filters,
        ...params,
      });
      
      console.log("RFQ RESPONSE", response.data);

      const result = response?.data?.data || {};

        console.log("RFQ RESPONSE", response.data);
        console.log("RFQ RESULT", result);

        setRecords(result.data || []);
        setSummary(result.summary || {});

        setPagination((prev) => ({
          ...prev,
          total: result.total || 0,
        }));

    } catch (err) {
      console.error("Failed to load RFQs", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.page]);

  return {
    loading,
    records,
    summary,
    pagination,
    setPagination,
    reload: loadData,
  };
}
